import { Link } from "react-router-dom";
import "./CaseStudies.css";
import "./Projects.css";
import mibunkerLarge from "./../images/mibunkerLarge.png";
import ucmaximusLarge from "./../images/ucmaximusLarge.png";
import starmaker from "./../images/starmaker.png";
import video from "./../images/video.svg";

function Projects() {
  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div class="projects-container">
      <section className="container">
        <div className="about-profile-title">
          <h4 className="title-label">My Projects</h4>
          <h2 className="home-subtitle">Work I have done in over a decade!</h2>
          <p>
            From conceptualizing ideas to bringing them to life, I've had the
            privilege of working on a diverse range of projects that have shaped
            my career and perspective.{" "}
            <i>
              <strong>
                A little outdated, but this section will be updated soon with my
                latest projects!
              </strong>
            </i>
          </p>
        </div>
        <nav className="projects-menu">
          <button className="button-sm" onClick={() => scrollTo("caseStudies")}>
            Case Studies
          </button>
          <button className="button-sm" onClick={() => scrollTo("hackathons")}>
            Hackathons
          </button>
          <button className="button-sm" onClick={() => scrollTo("workshops")}>
            Team Workshops
          </button>
          <button
            className="button-sm"
            onClick={() => scrollTo("presentations")}
          >
            Presentations
          </button>
          <button
            className="button-sm"
            onClick={() => scrollTo("short-articles")}
          >
            Short Articles
          </button>
        </nav>
        <div className="projects-design-content">
          <h4 id="caseStudies" style={{ scrollMarginTop: "130px" }}>
            Case Studies
          </h4>
          <div className="project-container">
            <div>
              <Link to="/mibunker">miBunker</Link>
              <p>
                I was approached by the co-founders of this startup to assist in
                the initiation of their project. Lacking prior experience in
                application development, they sought guidance in transforming
                their concept from branding into a functional prototype.
              </p>
            </div>
            <img
              className="cases-small-image"
              src={mibunkerLarge}
              alt="miBunker App"
            ></img>
          </div>
          <div className="project-container">
            <div>
              <Link to="/ucmaximus">UC Maximus</Link>
              <p>
                Design a branded microsite for UC Maximus, a medical education
                program tailored for Urgent Care Physicians. The challenge was
                to ensure the design felt distinct for this audience while still
                aligning with the playful, branded aesthetic of the parent
                website EM:RAP, which catered to Emergency Medicine Physicians.
              </p>
            </div>
            <img
              className="cases-small-image"
              src={ucmaximusLarge}
              alt="Urgent Care: Maximus"
            />
          </div>
          <div className="project-container">
            <div>
              <Link to="/starmaker">Starmaker</Link>
              <p>
                I was brought in as a UI designer to lead a visual refresh for
                the platform. While the focus was on enhancing the user
                interface and experience through a series of strategic design
                improvements the scope blew up into a full-scale redesign and
                code base rebuild.
              </p>
            </div>
            <img
              className="cases-small-image"
              src={starmaker}
              alt="Urgent Care: Maximus"
            />
          </div>
        </div>

        <div className="projects-design-content">
          <h4 id="hackathons" style={{ scrollMarginTop: "130px" }}>
            Hackathons
          </h4>
          <div className="design-hackathons">
            <ul>
              <li>
                <a href="https://github.com/malena/retreat-hackathon">
                  Covid Killer Hackathon Code
                </a>
                <p>
                  In 2020, during the height of the pandemic, I organized a team
                  retreat hackathon for our development and design teams. The
                  challenge was to create a game where floating COVID cells
                  could be "sprayed" and eliminated using the mouse—an engaging
                  way to combine creativity and stress relief.
                </p>
              </li>
              <li>
                <a href="https://github.com/silverorange/retreat-hackathon-2022">
                  Timezone Hackathon Code
                </a>
                <p>
                  In this hackathon, participants were instructed to build a
                  simple web page that displayed all employee time zones, making
                  it easier to coordinate meetings across distributed teams.
                </p>
              </li>
            </ul>
          </div>
        </div>
        <div className="projects-design-content">
          <h4 id="workshops" style={{ scrollMarginTop: "130px" }}>
            Team Workshops
          </h4>
          <div className="design-hackathons">
            <ul>
              <li>
                <a href="https://docs.google.com/presentation/d/1z03_75qUzuR-ZwpMlvDWqyqH50sFd27VZU7cISolswU/edit?usp=sharing">
                  Make your own Typography
                </a>
                <p>
                  After a short presentation on typography principles, I divided
                  the team into groups and challenged them to create their own
                  fonts using objects found around their homes—blending design
                  fundamentals with hands-on creativity.
                </p>
              </li>
              <li>
                <a href="https://docs.google.com/presentation/d/1TeK-QxsfUCn6npPqA9WIyVf_gwfUvFxNMcU_3A5S0sg/edit?usp=sharing">
                  What is Creativity?
                </a>
                <p>
                  This design exercise explored how creativity works in design,
                  using methods like conceptual blending to spark new ideas. The
                  activity included drawing an alien to encourage imaginative
                  thinking.
                </p>
              </li>
              <li>
                <a href="https://docs.google.com/presentation/d/11VcGiR5PVdPBuFjbShjzwLdVXiWIGKQKBDU3cZr1IXk/edit?usp=sharing">
                  Storyboarding
                </a>
                <p>
                  A collaborative design challenge where teams worked to solve
                  the problem: How can blind individuals know when they've been
                  in the sun too long? The goal was to invent a method that
                  helps reduce the risk of sunburn and skin cancer through
                  thoughtful, inclusive design.
                </p>
              </li>
              <li>
                <a href="https://docs.google.com/presentation/d/1ASj5oXj6gK1QMGUuh4AlkSePKqeQ2l37Y_d4Can21Cg/edit?slide=id.p#slide=id.p">
                  Timezone Hackathon
                </a>{" "}
                <p>
                  In this hackathon, participants were instructed to build a
                  simple web page that displayed all employee time zones, making
                  it easier to coordinate meetings across distributed teams.
                </p>
              </li>
            </ul>
          </div>
        </div>
        <div className="projects-design-content">
          <h4 id="presentations" style={{ scrollMarginTop: "130px" }}>
            Presentations & Show and Tells
          </h4>
          <p>
            In 2020, I enjoyed sharing new things I learned through informal
            presentations. While they were casual and done for fun, my team
            found them valuable and chose to record them. Below is a list of
            recordings from team meetings where I presented various topics
            inspired by the Human-Centered Design course I took on Coursera.
          </p>
          <ul className="design-video-list">
            <li>
              <a
                className="design-video-link"
                href="https://www.dropbox.com/scl/fi/vk9ti93ak21gf0ju1nnrf/2022-10-19.mp4?rlkey=7sj8lu0hyq9hr24sowqdorvge&dl=0"
              >
                <img
                  className="design-video-link-social-icon"
                  src={video}
                  alt="checkbox"
                />
                Human Centered Design: Crowd Sourcing
              </a>
            </li>
            <li>
              <a
                className="design-video-link"
                href="https://www.dropbox.com/scl/fi/r1af28l3d6pjtg94njm1m/2022-07-27.mp4?rlkey=mwl4y9wgs407tez8r9xrc7hpy&st=xwwrhse8&dl=0"
              >
                <img
                  className="design-video-link-social-icon"
                  src={video}
                  alt="checkbox"
                />
                Human Centered Design: Social Computing
              </a>
            </li>
            <li>
              <a
                className="design-video-link"
                href="https://www.dropbox.com/scl/fi/lpbpr7iau2y55efdzsxr4/2022-06-15.mp4?rlkey=3f2szv8vs3l44e92ozrpllvhu&st=rhf10mrh&dl=0"
              >
                <img
                  className="design-video-link-social-icon"
                  src={video}
                  alt="checkbox"
                />
                Human Centered Design: Comparing Rates
              </a>
            </li>
            <li>
              <a
                className="design-video-link"
                href="https://www.dropbox.com/scl/fi/urhfp7kebx2d1cjr67k3t/2022-05-20.mp4?rlkey=i2j6fth88pat5mkxcqy6124pn&st=3nwkh0yz&dl=0"
              >
                <img
                  className="design-video-link-social-icon"
                  src={video}
                  alt="checkbox"
                />
                Human Centered Design: Designing Experiments
              </a>
            </li>
            <li>
              <a
                className="design-video-link"
                href="https://www.dropbox.com/scl/fi/17i5w3723i3w701fr2idb/2022-05-18.mp4?rlkey=rqr2e1hd8e6baiis4uuwj5qi9&st=v4i1rq13&dl=0"
              >
                <img
                  className="design-video-link-social-icon"
                  src={video}
                  alt="checkbox"
                />
                Human Centered Design: Running Web Experiments
              </a>
            </li>
            <li>
              <a
                className="design-video-link"
                href="https://www.dropbox.com/scl/fi/9hdwtrtrwcw48cqnbjcwi/2022-03-09.mp4?rlkey=uu23kk38tp6zm7licuoq0gtgx&st=qranyyx1&dl=0"
              >
                <img
                  className="design-video-link-social-icon"
                  src={video}
                  alt="checkbox"
                />
                Human Centered Design: Visual and Information Design
              </a>
            </li>
            <li>
              <a
                className="design-video-link"
                href="https://www.dropbox.com/scl/fi/1bh1uetgfr91v7julxz1s/2022-02-23.mp4?rlkey=b2yh7ourarp7i6a7cnmlkzjxq&st=tzaggymx&dl=0"
              >
                <img
                  className="design-video-link-social-icon"
                  src={video}
                  alt="checkbox"
                />
                Human Centered Design: Design Principles
              </a>
            </li>
            <li>
              <a
                className="design-video-link"
                href="https://www.dropbox.com/scl/fi/ctdfp9j81wbb580lkzqb9/2021-12-15.mp4?rlkey=jctcfheqgkicp0b9ak8aw373f&st=t8vula2b&dl=0"
              >
                <img
                  className="design-video-link-social-icon"
                  src={video}
                  alt="checkbox"
                />
                Human Centered Design: Design Evaluation
              </a>
            </li>
            <li>
              <a
                className="design-video-link"
                href="https://www.dropbox.com/scl/fi/tm4si2abm4wg7woxm82xa/2021-11-03.mp4?rlkey=01987vs6eg8ylvw7r3k1s4wwa&st=upxxfbeo&dl=0"
              >
                <img
                  className="design-video-link-social-icon"
                  src={video}
                  alt="checkbox"
                />
                Human Centered Design: Rapid Prototyping
              </a>
            </li>
            <li>
              <a
                className="design-video-link"
                href="https://www.dropbox.com/scl/fi/msaxnq4dppxoirfepd6oc/2021-10-06-design-team-malenas-design-course-part2.mp4?rlkey=3k4bzkcz24lo62riul7jgc6u4&st=luihlefn&dl=0"
              >
                <img
                  className="design-video-link-social-icon"
                  src={video}
                  alt="checkbox"
                />
                Human Centered Design: How to get ideas
              </a>
            </li>
            <li>
              <a
                className="design-video-link"
                href="https://www.dropbox.com/scl/fi/gk5r2kcvx2p0qwrnrdgsv/CSS-Variables-2020-01-17.mp4?rlkey=0r267vmf6jwuq7ujc4hudguzl&st=3fd6fdbd&dl=0"
              >
                <img
                  className="design-video-link-social-icon"
                  src={video}
                  alt="checkbox"
                />
                An intro to CSS Variables
              </a>
            </li>
          </ul>
        </div>
        <div className="projects-design-content">
          <h4 id="short-articles" style={{ scrollMarginTop: "130px" }}>
            Short Articles
          </h4>
          <div className="design-hackathons">
            <ul>
              <li>
                <a href="https://www.silverorange.com/blog/2020-remote-remote-week">
                  Remote Week 2020
                </a>
                <p>
                  Silveroange traditionally hosted an annual in-person retreat
                  to foster team connection. However, in 2020, travel
                  restrictions during the pandemic made that impossible. I took
                  the lead in organizing a remote week filled with engaging
                  activities designed to bring the team together and maintain
                  our sense of connection.
                </p>
              </li>
              <li>
                <a href="https://www.silverorange.com/blog/roughing-things-in">
                  Roughing Things In - Commit small and merge fast as a team
                </a>
                <p>
                  An article that points to avoiding perfection in the first
                  iteration of the software cycle when working in a fast paced
                  collaborative environment.
                </p>
              </li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Projects;
